import { uuid } from '@gameday/common/utils'

import { auth, formData, promocode } from '../constants/actions'

const initialState = {
  codeValue: '',
  sessionId: null,
  validatedPromoCodes: [],
  errorMessage: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case promocode.SET_PROMOCODE_VALUE: {
      return {
        ...state,
        codeValue: action.payload,
      }
    }
    case promocode.INIT_PROMOCODE_SESSION:
      return state.sessionId
        ? state
        : {
            ...state,
            sessionId: uuid(),
          }
    case promocode.RESET_PROMOCODE_SESSION:
      return initialState
    case promocode.UPDATE_PROMOCODE: {
      const { add, remove } = action.payload

      if (add) {
        return {
          ...state,
          validatedPromoCodes: [...state.validatedPromoCodes, add],
        }
      }

      if (remove) {
        const { validatedPromoCodes = [] } = state
        const newPromoCodes = [...validatedPromoCodes]
        const promoCodeIndex = validatedPromoCodes.findIndex(p => p.code.id === remove)

        if (promoCodeIndex > -1) {
          newPromoCodes.splice(promoCodeIndex, 1)
        }

        return {
          ...state,
          validatedPromoCodes: newPromoCodes,
        }
      }

      return state
    }
    case promocode.PROMOCODE_ERROR: {
      return {
        ...state,
        errorMessage: action.payload,
      }
    }
    case auth.SIGN_OUT:
    case formData.RESET_FORM: {
      return initialState
    }
    default:
      return state
  }
}
